import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "fill-rule": "evenodd" }, [
      _createElementVNode("path", { d: "M.425 15h3.402V4.996H.425z" }),
      _createElementVNode("path", { d: "M.425 15h3.402V4.996H.425V15zm.012-.012h3.379v-9.98H.437v9.98zM14.911 5.74c-.721-.764-1.675-1.147-2.862-1.147-.437 0-.834.053-1.192.157a2.738 2.738 0 0 0-.905.44 4.394 4.394 0 0 0-.588.525 4.348 4.348 0 0 0-.406.535V4.826H5.533l.01.485c.007.323.01 1.32.01 2.99 0 1.671-.006 3.85-.02 6.539h3.425V9.252c0-.344.037-.617.114-.819.146-.344.366-.632.661-.864.295-.232.661-.349 1.098-.349.597 0 1.036.2 1.317.602.281.4.422.954.422 1.662v5.355h3.424V9.1c0-1.475-.36-2.595-1.083-3.36M3.326.496C2.98.169 2.518.006 1.942.006c-.576 0-1.043.163-1.4.49-.357.327-.536.74-.536 1.238 0 .491.173.902.52 1.232.347.33.805.496 1.374.496h.021c.583 0 1.053-.165 1.41-.496.358-.33.533-.74.526-1.232a1.662 1.662 0 0 0-.53-1.238" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "linkedin"}) } }